/* =====================================================================
   DEAD COTTON — Fiche du duo « Who's the boss? » (portage de la fiche duo du prototype, initPDP() de app.js)
   Données : <script id="dc-duo-data"> (variantes avec photo du DOS, devants par couleur).
   Chaque t-shirt (#1, #2) a sa couleur, son écriture et sa taille -> une variante Shopify chacun ;
   « Ajouter au panier » ajoute DEUX lignes (propriété « Duo » = « T-shirt #1 » / « T-shirt #2 »).
   Galerie : 2 diapos « paire » (les 2 dos côte à côte, puis les 2 devants). États : dc-is-active / dc-is-open / dc-is-on.
   ===================================================================== */
(function () {
  var root = document.querySelector("[data-dc-duo]");
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(document.getElementById("dc-duo-data").textContent); } catch (e) { return; }
  var variants = cfg.variants || [];
  var ci = cfg.colorIdx, si = cfg.sizeIdx, sti = cfg.styleIdx;
  var NNBSP = " ";

  var stage = root.querySelector("[data-dc-stage]");
  var dotsEl = root.querySelector("[data-dc-dots]");
  var navPrev = root.querySelector("[data-dc-prev]");
  var navNext = root.querySelector("[data-dc-next]");
  var zoomBtn = root.querySelector("[data-dc-zoom]");
  var form = root.querySelector("[data-dc-duo-form]");
  var buy = root.querySelector("[data-dc-pdp-add]");
  var priceEl = root.querySelector("[data-dc-price]");
  var gal = root.querySelector(".dc-pdp__gallery");
  var infoEl = root.querySelector(".dc-pdp__info");

  /* Titre sur une seule ligne */
  var titleH1 = root.querySelector(".dc-pdp__title");
  function fitTitle() {
    if (!titleH1) return;
    titleH1.style.fontSize = "";
    var avail = titleH1.clientWidth, need = titleH1.scrollWidth;
    if (need > avail) {
      var base = parseFloat(getComputedStyle(titleH1).fontSize);
      titleH1.style.fontSize = Math.max(12, Math.floor(base * (avail / need) * 99) / 100) + "px";
    }
  }
  fitTitle();
  window.addEventListener("resize", fitTitle);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);

  /* Description : une phrase par ligne sous l'accroche ; « (Pas nous… chut, il écoute.) » = phrase chuchotée (petite, italique, grise) */
  var descEl = root.querySelector("[data-dc-desc]");
  if (descEl) {
    descEl.querySelectorAll("p:not(:first-child)").forEach(function (para) {
      var t = para.textContent.trim();
      if (t.charAt(0) === "(" && t.charAt(t.length - 1) === ")") para.classList.add("dc-whisper");
    });
  }

  var backEl = root.querySelector("[data-dc-back]");
  if (backEl) {
    backEl.addEventListener("click", function (e) {
      if (document.referrer.indexOf(location.origin) === 0 && history.length > 1) { e.preventDefault(); history.back(); }
    });
  }

  /* ---------------------------------------------------------------
     Choix des 2 t-shirts
  --------------------------------------------------------------- */
  var cols = [1, 2].map(function (k) { return root.querySelector('.dc-duo-opts__col[data-k="' + k + '"]'); });
  var sel = cols.map(function (col) {
    var s = {};
    ["color", "size"].forEach(function (kind) {
      var a = col.querySelector('[data-kind="' + kind + '"].dc-is-active');
      s[kind] = a ? a.getAttribute("data-value") : null;
    });
    s.style = cfg.defaultStyle || null;   // 2026-11-02 : plus de choix « Écriture » (un seul dos par couleur) ; s'il reste une option sur le produit, on prend sa 1re valeur
    return s;
  });

  function findVariant(s) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options;
      if (o[ci] === s.color && o[si] === s.size && (sti < 0 || o[sti] === s.style)) return variants[i];
    }
    return null;
  }

  /* ---------------------------------------------------------------
     Galerie : diapos « paire »
  --------------------------------------------------------------- */
  var galleryCount = 0, currentIdx = 0;
  var slideStep = function () {
    return (stage.children.length > 1 ? stage.children[1].offsetLeft - stage.children[0].offsetLeft : stage.clientWidth) || 1;
  };
  var LOOP_MS = 650;

  function refreshArrows() {
    var single = galleryCount <= 1;
    if (navPrev) navPrev.hidden = single;
    if (navNext) navNext.hidden = single;
  }
  function setActive(i) {
    currentIdx = i;
    if (dotsEl) Array.prototype.forEach.call(dotsEl.children, function (d, di) { d.classList.toggle("dc-is-active", di === i); });
    refreshArrows();
  }
  function goTo(i) {
    stage.scrollTo({ left: i * slideStep(), behavior: "smooth" });
    setActive(i);
  }
  function loopNext() {
    var n = galleryCount, step = slideStep();
    var clone = stage.children[0].cloneNode(true);
    stage._busy = true;
    stage.appendChild(clone);
    stage.scrollTo({ left: n * step, behavior: "smooth" });
    setActive(0);
    setTimeout(function () {
      clone.remove();
      stage.style.scrollSnapType = "none";
      stage.scrollLeft = 0;
      requestAnimationFrame(function () { stage.style.scrollSnapType = ""; stage._busy = false; });
    }, LOOP_MS);
  }
  function loopPrev() {
    var n = galleryCount;
    var clone = stage.children[n - 1].cloneNode(true);
    stage._busy = true;
    stage.style.scrollSnapType = "none";
    stage.insertBefore(clone, stage.firstChild);
    stage.scrollLeft = slideStep();
    requestAnimationFrame(function () {
      stage.style.scrollSnapType = "";
      stage.scrollTo({ left: 0, behavior: "smooth" });
      setActive(n - 1);
      setTimeout(function () {
        clone.remove();
        stage.style.scrollSnapType = "none";
        stage.scrollLeft = (n - 1) * slideStep();
        requestAnimationFrame(function () { stage.style.scrollSnapType = ""; stage._busy = false; });
      }, LOOP_MS);
    });
  }
  if (navPrev) navPrev.addEventListener("click", function () { if (stage._busy) return; currentIdx <= 0 ? loopPrev() : goTo(currentIdx - 1); });
  if (navNext) navNext.addEventListener("click", function () { if (stage._busy) return; currentIdx >= galleryCount - 1 ? loopNext() : goTo(currentIdx + 1); });
  var scrollTimer;
  stage.addEventListener("scroll", function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { if (!stage._busy) setActive(Math.round(stage.scrollLeft / slideStep())); }, 80);
  });

  function pairSlide(items) {
    var slide = document.createElement("div");
    slide.className = "dc-pdp__slide dc-pdp__slide--pair";
    var pair = document.createElement("div");
    pair.className = "dc-pdp__pair";
    items.forEach(function (it, k) {
      var fig = document.createElement("figure");
      var im = document.createElement("img");
      im.src = it.src; im.alt = "Who's the boss? — T-shirt #" + (k + 1);
      im.setAttribute("data-full", it.full || it.src);
      var tag = document.createElement("span");
      tag.className = "dc-pdp__tag"; tag.textContent = "#" + (k + 1);
      fig.appendChild(im); fig.appendChild(tag); pair.appendChild(fig);
    });
    slide.appendChild(pair);
    return slide;
  }
  function renderGallery() {
    var v = [findVariant(sel[0]), findVariant(sel[1])];
    var backs = sel.map(function (s, k) {   // dos = fichier du thème par couleur (2026-11-02) ; repli : photo de la variante
      var u = cfg.backs && cfg.backs[s.color];
      return { src: u || (v[k] && v[k].image), full: u || (v[k] && v[k].full) };
    });
    var fronts = sel.map(function (s) { var u = cfg.fronts[s.color]; return { src: u, full: u }; });
    var slides = [];
    if (backs[0].src && backs[1].src) slides.push(pairSlide(backs));
    if (fronts[0].src && fronts[1].src) slides.push(pairSlide(fronts));
    if (!slides.length) return;
    stage.replaceChildren.apply(stage, slides);
    stage.scrollLeft = 0;
    galleryCount = slides.length;
    if (dotsEl) {
      dotsEl.innerHTML = "";
      if (galleryCount > 1) {
        for (var i = 0; i < galleryCount; i++) {
          var d = document.createElement("button");
          d.type = "button"; d.className = "dc-pdp__dot" + (i === 0 ? " dc-is-active" : "");
          d.setAttribute("aria-label", "Photo " + (i + 1));
          (function (n) { d.addEventListener("click", function () { goTo(n); }); })(i);
          dotsEl.appendChild(d);
        }
      }
    }
    setActive(0);
  }
  function goToPhoto(i) { stage.scrollTo({ left: i * slideStep(), behavior: "auto" }); setActive(i); }

  /* Visionneuse plein écran (bouton « + ») */
  if (zoomBtn) {
    var lb = document.createElement("div");
    lb.className = "dc-r dc-lightbox";
    lb.hidden = true;
    lb.innerHTML =
      '<button type="button" class="dc-lightbox__close" aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="dc-lightbox__nav dc-lightbox__nav--prev" aria-label="Photo précédente"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="dc-lightbox__nav dc-lightbox__nav--next" aria-label="Photo suivante"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="dc-lightbox__track"></div>';
    document.body.appendChild(lb);
    var track = lb.querySelector(".dc-lightbox__track");
    var lprev = lb.querySelector(".dc-lightbox__nav--prev");
    var lnext = lb.querySelector(".dc-lightbox__nav--next");
    var lbStep = function () { return (track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : track.clientWidth) || 1; };
    var lbIndex = function () { return Math.round(track.scrollLeft / lbStep()); };
    var refreshNav = function () { var i = lbIndex(), n = track.children.length; lprev.hidden = i <= 0; lnext.hidden = i >= n - 1; };
    var openLb = function () {
      track.innerHTML = "";
      Array.prototype.forEach.call(stage.children, function (s) {
        var slide = document.createElement("div");
        slide.className = "dc-lightbox__slide dc-lightbox__slide--pair";
        s.querySelectorAll("img").forEach(function (im) {
          var big = document.createElement("img");
          big.src = im.getAttribute("data-full") || im.currentSrc || im.src;
          big.alt = im.alt;
          slide.appendChild(big);
        });
        track.appendChild(slide);
      });
      lb.hidden = false;
      document.body.style.overflow = "hidden";
      track.scrollTo({ left: currentIdx * lbStep(), behavior: "auto" });
      refreshNav();
    };
    var closeLb = function () {
      if (lb.hidden) return;
      var i = lbIndex();
      lb.hidden = true;
      document.body.style.overflow = "";
      goToPhoto(i);
    };
    zoomBtn.addEventListener("click", openLb);
    lb.querySelector(".dc-lightbox__close").addEventListener("click", closeLb);
    lprev.addEventListener("click", function () { track.scrollBy({ left: -lbStep(), behavior: "smooth" }); });
    lnext.addEventListener("click", function () { track.scrollBy({ left: lbStep(), behavior: "smooth" }); });
    var lbTimer;
    track.addEventListener("scroll", function () { clearTimeout(lbTimer); lbTimer = setTimeout(refreshNav, 60); });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") closeLb();
      else if (e.key === "ArrowLeft") lprev.click();
      else if (e.key === "ArrowRight") lnext.click();
    });
  }

  /* ---------------------------------------------------------------
     Prix (2 t-shirts − remise), disponibilité, libellés de couleur
  --------------------------------------------------------------- */
  var ADD = cfg.labels.add, SOLD = cfg.labels.soldOut, UNAV = cfg.labels.unavailable;
  var fmt = function (cents) { return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var current = [null, null];
  function updatePrice() {
    var a = current[0], b = current[1];
    if (!a || !b || !priceEl) return;
    var base = a.price + b.price;
    var disc = Math.round(base * (100 - cfg.discountPct) / 100);
    priceEl.innerHTML = (cfg.discountPct > 0 ? "<s>" + fmt(base) + NNBSP + "€</s>" : "") + fmt(disc) + NNBSP + "€";
  }
  function refreshButtons() {
    var ok = current[0] && current[1] && current[0].available && current[1].available;
    var label = !(current[0] && current[1]) ? UNAV : (ok ? ADD : SOLD);
    var sbtn = document.querySelector("[data-dc-sticky-add]");
    [buy, sbtn].forEach(function (b) { if (b) { b.disabled = !ok; b.textContent = label; } });
  }
  function refreshAll(rerenderGallery) {
    cols.forEach(function (col, k) {
      ["color", "size"].forEach(function (kind) {
        col.querySelectorAll('[data-kind="' + kind + '"]').forEach(function (chip) {
          chip.classList.toggle("dc-is-active", chip.getAttribute("data-value") === sel[k][kind]);
        });
      });
      var lab = col.querySelector("[data-dc-color-label]");
      if (lab) lab.textContent = sel[k].color;
      current[k] = findVariant(sel[k]);
    });
    updatePrice();
    refreshButtons();
    if (rerenderGallery) renderGallery();
  }
  cols.forEach(function (col, k) {
    col.querySelectorAll("[data-dc-chip]").forEach(function (chip) {
      var kind = chip.getAttribute("data-kind"), val = chip.getAttribute("data-value");
      chip.addEventListener("click", function () { sel[k][kind] = val; refreshAll(kind !== "size"); });
      if (kind === "color") {   // survol : aperçu du nom de la couleur
        var lab = col.querySelector("[data-dc-color-label]");
        chip.addEventListener("mouseenter", function () { if (lab) lab.textContent = val; });
        chip.addEventListener("mouseleave", function () { if (lab) lab.textContent = sel[k].color; });
      }
    });
  });
  refreshAll(true);

  /* ---------------------------------------------------------------
     Ajout au panier : 2 lignes
  --------------------------------------------------------------- */
  function refreshCartBubble() {
    return fetch("/?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (data) {
      var html = data["cart-icon-bubble"];
      var target = document.querySelector("#cart-icon-bubble");
      if (!html || !target) return;
      var tmp = document.createElement("div");
      tmp.innerHTML = html;
      var fresh = tmp.querySelector("#cart-icon-bubble");
      target.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
    });
  }
  function addToCart() {
    if (!current[0] || !current[1] || !current[0].available || !current[1].available) return;
    var btns = [buy, document.querySelector("[data-dc-sticky-add]")].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });
    var uid = String(Date.now());   // propriété cachée (« _ ») qui relie les 2 lignes d'un même duo : le panier les regroupe en un bloc
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      // #2 d'abord : Shopify affiche la ligne la plus récente en haut, donc #1 apparaît avant #2 dans le panier
      body: JSON.stringify({ items: [
        { id: current[1].id, quantity: 1, properties: { "Duo": "T-shirt #2", "_duo": uid } },
        { id: current[0].id, quantity: 1, properties: { "Duo": "T-shirt #1", "_duo": uid } }
      ] })
    }).then(function (r) { if (!r.ok) throw new Error("add"); return typeof window.dcOpenCart === "function" ? window.dcOpenCart() : refreshCartBubble(); })
      .catch(function () {
        btns.forEach(function (b) { b.textContent = UNAV; });
        return new Promise(function (res) { setTimeout(res, 1400); });
      })
      .then(refreshButtons);
  }
  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(); });

  /* Barre « Ajouter au panier » fixe (mobile) */
  var sticky = document.querySelector("[data-dc-sticky]");
  if (sticky && buy) {
    sticky.querySelector("[data-dc-sticky-add]").addEventListener("click", function () { addToCart(); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle("dc-is-on", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(buy);
    }
  }

  /* ---------------------------------------------------------------
     Accordéon (ordinateur) + mobile : détails en liste grise + liens qui ouvrent un encart
  --------------------------------------------------------------- */
  var accItems = Array.prototype.slice.call(root.querySelectorAll(".dc-accordion__item"));
  accItems.forEach(function (item) {
    var btn = item.querySelector(".dc-accordion__btn");
    btn.addEventListener("click", function () {
      var open = item.classList.toggle("dc-is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
  var storyEl = root.querySelector(".dc-pdp__story");
  if (storyEl && accItems.length >= 1) {
    var specs = document.createElement("ul");
    specs.className = "dc-pdp__specs";
    var firstList = accItems[0].querySelector(".dc-accordion__panel ul");
    specs.innerHTML = firstList ? firstList.innerHTML : "";
    storyEl.appendChild(specs);
    // Pastilles « impact » sous « Détails du produit » (2026-10-18) : ordinateur = copie juste après le 1er item de l'accordéon ; mobile = l'original entre la liste grise et les liens.
    var ecoEl = storyEl.querySelector("[data-dc-eco]");
    if (ecoEl) { accItems[0].insertAdjacentElement("afterend", ecoEl.cloneNode(true)); storyEl.appendChild(ecoEl); }
    if (accItems.length > 1) {
      var links = document.createElement("div");
      links.className = "dc-pdp__links";
      accItems.slice(1).forEach(function (item, k) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("data-dc-pop", String(k + 1));
        b.textContent = item.querySelector(".dc-accordion__btn").firstChild.textContent.trim();
        links.appendChild(b);
      });
      storyEl.appendChild(links);

      var pop = document.createElement("div");
      pop.className = "dc-r dc-pdp-pop";
      pop.hidden = true;
      pop.innerHTML =
        '<div class="dc-pdp-pop__card" role="dialog" aria-modal="true">' +
        '<button type="button" class="dc-pdp-pop__close" aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<h2 class="dc-pdp-pop__title"></h2><ul class="dc-pdp-pop__body"></ul></div>';
      document.body.appendChild(pop);
      var closePop = function () { pop.hidden = true; document.body.style.overflow = ""; };
      links.querySelectorAll("[data-dc-pop]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var item = accItems[Number(btn.getAttribute("data-dc-pop"))];
          pop.querySelector(".dc-pdp-pop__title").textContent = btn.textContent;
          var list = item.querySelector(".dc-accordion__panel ul");
          pop.querySelector(".dc-pdp-pop__body").innerHTML = list ? list.innerHTML : "<li>" + item.querySelector(".dc-accordion__panel").textContent.trim() + "</li>";
          pop.hidden = false;
          document.body.style.overflow = "hidden";
        });
      });
      pop.addEventListener("click", function (e) { if (e.target === pop) closePop(); });
      pop.querySelector(".dc-pdp-pop__close").addEventListener("click", closePop);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !pop.hidden) closePop(); });
    }
  }

  /* ---------------------------------------------------------------
     Duo (ordinateur ≥ 901 px) : photos à gauche, dont la HAUTEUR = celle de la colonne de droite ;
     description + détails presque collés sous les photos. Mobile : ordre d'origine. Fait en dernier.
  --------------------------------------------------------------- */
  var mq = window.matchMedia("(min-width: 901px)");
  var under = document.createElement("div");
  under.className = "dc-pdp__duo-under";
  var placeUnder = function () {
    var parts = [root.querySelector(".dc-pdp__story"), root.querySelector(".dc-accordion")];
    if (parts.some(function (x) { return !x; })) return;
    if (mq.matches) { parts.forEach(function (p) { under.appendChild(p); }); gal.appendChild(under); }
    else { parts.forEach(function (p) { infoEl.appendChild(p); }); under.remove(); }
  };
  placeUnder();
  mq.addEventListener("change", placeUnder);
  var syncStageH = function () {
    stage.style.aspectRatio = mq.matches ? "auto" : "";
    stage.style.height = mq.matches ? infoEl.offsetHeight + "px" : "";
    gal.style.setProperty("--dc-stage-h", stage.offsetHeight + "px");
  };
  mq.addEventListener("change", syncStageH);
  syncStageH();
  if ("ResizeObserver" in window) new ResizeObserver(syncStageH).observe(infoEl);
})();
